module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1004-929e6e11a6873fedd686b0b082741f9a.png";